module.exports = __webpack_public_path__ + "static/media/Studies_Header.212f3ebb.png";